let $ = require('jquery');
import svg4everybody from 'svg4everybody';
import enquire from 'enquire.js';


function start() {

  $.event.special.touchstart = {
    setup: function( _, ns, handle ) {
      this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
  };
  $.event.special.touchmove = {
    setup: function( _, ns, handle ) {
      this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
  };
  $.event.special.wheel = {
    setup: function( _, ns, handle ){
      this.addEventListener("wheel", handle, { passive: true });
    }
  };
  $.event.special.mousewheel = {
    setup: function( _, ns, handle ){
      this.addEventListener("mousewheel", handle, { passive: true });
    }
  };

  // align article Newsletter para
  alignArticleNewsletter();

  // SVG for IE too
  svg4everybody({validate: function (src, svg, use) {
    // logo is already loading
    if (src == '#icon-logo') {
      return false;
    }
    return true;
  }});

  // like/dislike vote button
  $('.like').on('mousedown touchstart', function() {
    $(this).addClass('like--on');
  });

  // nice thumbnail for videos
  $('.author-video__playbutton').on('click', function() {
    $(this).hide();
    $('.author-video__thumbnail').hide();
    // @todo play video on first click
  });

  // window resize
  $(window).on('resize', alignArticleNewsletter);
}

function alignArticleNewsletter() {
  $('.newsletter-block--article').offset({left: 0});
  $('.newsletter-block--article').width($('body').width());
}

export default start;
